export { default } from './index.vue';


// WEBPACK FOOTER //
// ./packages/wxc-rich-text/index.js